import { Component, EventEmitter, Output, Input } from '@angular/core';

import { Asset } from '@digital-platform/shared/domain';

@Component({
  selector: 'digital-platform-tracker-detail-popup',
  templateUrl: './tracker-detail-popup.component.html',
  styleUrls: ['./tracker-detail-popup.component.scss'],
})
export class TrackerDetailPopupComponent {
  @Input() marker: Asset;
  @Output() editEvent = new EventEmitter<Asset>();

  edit() {
    this.editEvent.emit(this.marker);
  }

  getLatestCheckInHistory() {
    let locations = this.marker?.location;
    locations = locations.sort((x, y) => y.timeMs - x.timeMs);
    return locations[0]?.timeMs;
  }

  getDormatoryDuration() {
    const currentDate = new Date();
    const checkInDate = new Date(this.getLatestCheckInHistory());
    return Math.floor(
      (currentDate.getTime() - checkInDate.getTime()) / (1000 * 3600 * 24)
    );
  }
}
